// refactor sass to stylejs (no theme usage)
import { css } from '@emotion/react';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(
  () => css`
    &.ui-dialog {
      &.card {
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1), 0 0 0 1px #fcfcfc;
        overflow: hidden;

        .card-header {
          border-radius: 8px;
          height: 48px;
          background: #ffffff;
          border: 1px solid #f5f5f5;
          position: relative;
          font-size: 1rem;
          font-weight: 800;
        }

        .card-body,
        .card-footer {
          background: #ffffff;
        }
      }
      .dialog-support {
        position: absolute;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        height: 45px;
        width: 45px;

        &.right {
          right: -60px;
          animation: goToRight 0.3s ease;
        }

        &.left {
          left: -60px;
          animation: goToLeft 0.3s ease;
        }

        &.open {
          left: 0;
        }
        .container {
          z-index: 99;
          position: absolute;
          width: 320px;
          height: fit-content;
          left: 0;
          top: 50px;
          background: #ffffff;
          border: 1px solid #eeeeee;
          box-shadow: -2px 2px 10px rgba(0, 0, 0, 0.12);
          border-radius: 12px;
          visibility: hidden;
          transition: all 0.3s;
          opacity: 0;
          overflow: hidden;
          cursor: default;
          .ui-alert {
            background: #e1e8ff !important;
          }
          &.open {
            opacity: 1;
            visibility: visible;
            bottom: 50px;
          }
        }
      }
    }

    @keyframes goToRight {
      from {
        right: 20px;
      }
      to {
        right: -60px;
      }
    }

    @keyframes goToLeft {
      from {
        left: 20px;
      }
      to {
        left: -60px;
      }
    }

    @media (max-width: 900px) {
      &.ui-dialog {
        .hide-in-mobile-size {
          display: none !important;
        }
      }
    }
  `
);
